import React from "react";
import { Box, Typography } from "@mui/material";
import StarRoundedIcon from '@mui/icons-material/StarRounded';

const CommonHeroSection = ({
    title,
    bgImage = "",
    height = "300px",
}) => {
    return (
        <Box
            sx={{
                position: "relative",
                height,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                overflow: "hidden",
                backgroundImage: bgImage ? `url(${bgImage})` : "none",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundColor: "#9e9e9e", // fallback grey
            }}
        >
            {/* GREY OVERLAY */}
            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    background: "rgba(0,0,0,0.45)", // dark overlay like image
                }}
            />

            {/* CONTENT */}
            <Box sx={{ position: "relative", zIndex: 2 }}>
                {/* STARS */}
                <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
                    <StarRoundedIcon sx={{ color: "#cfd8dc", fontSize: 18, mt: 0.5 }} />
                    <StarRoundedIcon sx={{ color: "#f5c242", fontSize: 22, mx: 0.5 }} />
                    <StarRoundedIcon sx={{ color: "#cfd8dc", fontSize: 18, mt: 0.5 }} />
                </Box>

                {/* TITLE */}
                <Typography
                    sx={{
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: {
                            xs: "28px",
                            sm: "36px",
                            md: "48px",
                        },
                        letterSpacing: "1px",
                    }}
                >
                    {title}
                </Typography>
            </Box>
        </Box>
    );
};

export default CommonHeroSection;